import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoColorPaletteMixin from './KendoColorPaletteMixin'

export default {
    name: 'kendo-colorpalette',
    mixins: [ KendoColorPaletteMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPalette/index.js